module.exports = __webpack_public_path__ + "media/images/landing/second/photo23-75087fa8f6fac1b67fa17dc80a2393ca.jpg";